import { type RelationEditor } from '@framework/form/form/relations/useRelationEditor.ts';
import { Button, Space } from 'antd';
import type * as React from 'react';
import { DrawerButtonRow } from './DrawerButtonRow.tsx';

export interface IDrawerEditorButtonRowProps {
  editor: RelationEditor<any>;
  /** Sostituisce il testo "Annulla" */
  cancelText?: React.ReactNode;
  /** Sostituisce il testo "Applica" */
  submitText?: React.ReactNode;
}

/**
 * Versone del `DrawerButtonRow` già collegato con:
 * - `useRelationEditor`, accetta in ingresso un `editor`. Quando si preme
 *   su "Annulla", viene chiamato `editor.handle.cancel()`.
 * - `FormHandler` per l'invio; l'onSubmit viene gestito con il context,
 *   quindi non è necessario passarlo. (htmlType="submit")
 */
export function DrawerEditorButtonRow(props: IDrawerEditorButtonRowProps) {
  const { editor, cancelText, submitText } = props;

  return (
    <DrawerButtonRow>
      <Space>
        <Button size="large" onClick={editor.handle.cancel}>
          {cancelText ?? 'Annulla'}
        </Button>
        <Button type="primary" htmlType="submit" size="large">
          {submitText ?? 'Applica'}
        </Button>
      </Space>
    </DrawerButtonRow>
  );
}
